var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component, Fragment } from "react";
import styled from "styled-components";
import UserSearch from "@irati/ui/src/UserSearch";
import { FormattedMessage } from "@irati/utils/lang";
import { greys } from "@irati/ui/src/global/colors";
import padding from "@irati/ui/src/global/padding";
import tracking from "@irati-tracking/wallet/tenantWallet";
import SelectedManager from "../SelectedManager";
var StyledRow = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n  margin-bottom: ", ";\n  padding-bottom: 10px;\n"], ["\n  border-bottom: 1px solid ", ";\n  margin-bottom: ", ";\n  padding-bottom: 10px;\n"])), greys.light, padding.tiny);
var FlexRow = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  .form-group {\n    width: 100%;\n  }\n  .col-xs-12 {\n    padding: 0px;\n  }\n"], ["\n  display: flex;\n  .form-group {\n    width: 100%;\n  }\n  .col-xs-12 {\n    padding: 0px;\n  }\n"])));
var SelectRecipients = /** @class */ (function (_super) {
    __extends(SelectRecipients, _super);
    function SelectRecipients() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasTrackingEventFired: false
        };
        _this.handleClick = function () {
            if (!_this.state.hasTrackingEventFired) {
                tracking.updateManager();
                _this.setState({ hasTrackingEventFired: true });
            }
        };
        _this.handleSelectUser = function (_, user) {
            if (user) {
                _this.props.addRecipient(user);
            }
        };
        return _this;
    }
    SelectRecipients.prototype.render = function () {
        var _a = this.props, recipients = _a.recipients, removeRecipient = _a.removeRecipient;
        return (React.createElement(Fragment, null,
            React.createElement(FlexRow, { onClick: this.handleClick },
                React.createElement(UserSearch, { id: "tenantWalletRecipientSelector", label: "wallet.tenant.recipients.title", onChange: this.handleSelectUser, placeholder: "wallet.tenant.recipients.placeholder", controlShouldRenderValue: false })),
            recipients.length > 0 && (React.createElement(StyledRow, null,
                React.createElement(FormattedMessage, { id: "wallet.tenant.recipients.list.title" }))),
            recipients.map(function (user, index) { return (React.createElement(SelectedManager, { key: user.uuid, index: index, removeUser: removeRecipient, user: user })); })));
    };
    return SelectRecipients;
}(Component));
export default SelectRecipients;
var templateObject_1, templateObject_2;
